import axios from 'axios'

export default {
    namespace: true,
    state: {
        users: null,
        userModalShow: false,
    },
    getters: {
        getUsers(state) { return state.users },
        getUserModalShow(state) { return state.userModalShow },
    },
    mutations: {
        setUsers(state, data) { return state.users = data },
        setUserModalShow(state, data) { return state.userModalShow = data },
    },
    actions: {
        async requestUsers({ commit, state }, data) {
            try {
                // const res = await axios.get('api/admin/users');
                const data = [
                    {id: 1, phone: '+998-**-***7017', balance: 1000000, total: 800},
                    {id: 2, phone: '+998-**-***7018', balance: 0, total: 60},
                    {id: 3, phone: '+998-**-***7019', balance: 356000000, total: 6500.23},
                    {id: 4, phone: '+998-**-***7011', balance: 200, total: 3000},
                    {id: 5, phone: '+998-**-***7012', balance: 230000, total: 2341.51},
                ]
                commit('setUsers', data);
            } catch (error) {
                console.error('Error fetching users:', error);
            }
        },
    }
}
